const pathObj = {
  // ─── Auth & User ──────────────────────────────────────────────────────
  loginUser: "/v1/companyAdmin/login",
  changePassword: "/v1/companyAdmin/change-password",
  forgotPassword: "/v1/companyAdmin/forgot-password",
  getLogs: "/v1/admin/logs",
  refreshToken: "/v1/user/refresh-token",
  userProfile: "/v1/user/profile",
  logout: "/v1/companyAdmin/logout",
  resetPassword: "/v1/companyAdmin/company-reset-password",

  // ─── Departments & Skills ─────────────────────────────────────────────
  departmentList: "/v1/companyAdmin/department",
  departmentStatus: "/v1/companyAdmin/department/change-status",
  departmentAdd: "/v1/companyAdmin/department",
  departmentUpdate: "/v1/companyAdmin/department",
  departmentDeleteByDepartmentId: "/v1/companyAdmin/department/by-id/:departmentId",
  skillList: "/v1/companyAdmin/skills",
  skillStatus: "/v1/companyAdmin/skills/change-status",
  skillAdd: "/v1/companyAdmin/skills",
  skillUpdate: "/v1/companyAdmin/skills",
  getDepartmentList: "/v1/companyAdmin/department/list",

  // ─── Jobs & Requirements ──────────────────────────────────────────────
  getJobs: "/v1/companyAdmin/jobs",
  manageAdd: "/v1/companyAdmin/jobs",
  manageEdit: "/v1/companyAdmin/jobs",
  manageDelete: "/v1/companyAdmin/jobs",
  listWithoutPagination: "/v1/companyAdmin/jobs/list",
  jobsStatus: "/v1/companyAdmin/jobs/change-status",
  getCategoryList: "/v1/companyAdmin/jobs/list",
  generateAIContent: "/v1/companyAdmin/jobs/generate-ai-content",
  getBillingSummary: "/v1/companyAdmin/jobs/billing-summary",
  getJobBillingBreakdown: "/v1/companyAdmin/jobs/billing-breakdown",

  // ─── Geography / Onboarding ───────────────────────────────────────────
  getCountryList: "/v1/admin/country/list",
  getStateList: "/v1/admin/state/list-by-country",
  editProfile: "/v1/companyAdmin/profile",
  getDashboardDetails: "/v1/companyAdmin/dashboard",
  OnboardingList: "/v1/companyAdmin/hr",
  onboardingDelete: "/v1/companyAdmin/hr",
  onboardingStatus: "/v1/companyAdmin/hr/change-status",
  onboardingAdd: "/v1/companyAdmin/hr",
  onboardingEdit: "/v1/companyAdmin/hr",
  accountantOnboardingList: "/v1/companyAdmin/accountant",
  accountantOnboardingDelete: "/v1/companyAdmin/accountant",
  accountantOnboardingStatus: "/v1/companyAdmin/accountant/change-status",
  accountantOnboardingAdd: "/v1/companyAdmin/accountant",
  accountantOnboardingEdit: "/v1/companyAdmin/accountant",
  allHR: "/v1/companyAdmin/hr/list",
  allAccountant: "/v1/companyAdmin/accountant/list",

  // ─── Support & Notifications ──────────────────────────────────────────
  getSupport: "/v1/companyAdmin/queries",
  supportAdd: "/v1/companyAdmin/queries",
  getSubscription: "/v1/companyAdmin/my-subscription",
  getNotification: "/v1/companyAdmin/notification",
  notificationAdd: "/v1/companyAdmin/notification",
  checkNotification: "/v1/companyAdmin/notification/check-notification",
  getBellNotification: "/v1/companyAdmin/notification/listNotification-via-admin",

  // ─── Job Requests & Employees ─────────────────────────────────────────
  requestList: "/v1/companyAdmin/jobRequests",
  deleteJobRequest: "/v1/companyAdmin/jobRequests/job-request",
  ChangeStatusJob: "/v1/companyAdmin/jobRequests/status-change",
  employeeList: "/v1/companyAdmin/jobRequests/list-accepted-rejected-request",
  getTotalEmployee: "/v1/companyAdmin/jobRequests/total-accepted-employee-list",
  changeEmployeeStatus: "/v1/companyAdmin/jobRequests/employee-status-change",
  updateReply: "/v1/companyAdmin/jobRequests/status-change",

  // ─── Leaves & Timesheets ──────────────────────────────────────────────
  employeeLeaveList: "/v1/companyAdmin/leaves/list",
  employeeLeaveRequest: "/v1/companyAdmin/leaves",
  changeLeaveStatus: "/v1/companyAdmin/leaves",
  companyDepartmentList: "/v1/companyAdmin/leaves/department-list",
  timesheetList: "/v1/companyAdmin/employee-timesheet",
  employeeLists: "/v1/companyAdmin/employee-list",
  downloadBiometric: "/v1/companyAdmin/download-employeeTimeSheet",

  // ─── Forms ────────────────────────────────────────────────────────────
  allForms: "/v1/user/list-forms",
  getForms: "/v1/companyAdmin/forms",
  getFormsById: "/v1/companyAdmin/forms/formById",
  addForm: "/v1/companyAdmin/forms/add",
  updateForm: "/v1/companyAdmin/forms/update",
  deleteCustomField: (formId, fieldId) => `/v1/companyAdmin/forms/${formId}/field/${fieldId}`,
  editForm: "/v1/companyAdmin/forms/edit",
  deleteForm: "/v1/companyAdmin/forms/delete",
  changeFormStatus: "/v1/companyAdmin/forms/change-status",
  getSuggestedForms: "/v1/companyAdmin/suggested-forms",
  addSuggestedForm: "/v1/companyAdmin/suggested-forms/add",
  companyCompletionStatus: "/v1/companyAdmin/company-completion-status",

  // ─── Tasks ────────────────────────────────────────────────────────────
  getEmployeeList: "/v1/companyAdmin/tasks/employee-list",
  getTimeZoneList: "/v1/companyAdmin/tasks/timezones",
  taskAdd: "/v1/companyAdmin/tasks/assign-task",
  allTaskSchedulingList: "/v1/companyAdmin/tasks/list",
  taskEdit: "/v1/companyAdmin/tasks/edit-task",
  taskDelete: "/v1/companyAdmin/tasks/delete-task",
  cancelTask: "/v1/companyAdmin/tasks/cancel-task",
  taskReassign: "/v1/companyAdmin/tasks/reassign-task",
  getTimeLogList: "/v1/companyAdmin/tasks/time-logs",
  employeeRecommendation: "/v1/companyAdmin/employee-recommendation",
  updateSubscriptionEmployees: "/v1/user/company/update-subscription-employees",

  // ─── MFA ──────────────────────────────────────────────────────────────
  mfaStatus: "/v1/mfa/status",
  mfaSetupInitiate: "/v1/mfa/setup/initiate",
  mfaSetupVerify: "/v1/mfa/setup/verify",
  mfaVerify: "/v1/mfa/verify",
  mfaVerifyRecoveryCode: "/v1/mfa/verify-recovery-code",
  mfaRecoveryCodesRegenerate: "/v1/mfa/recovery-codes/regenerate",
  mfaDisable: "/v1/mfa/disable",
  mfaLoginVerify: "/v1/mfa/login/verify",
  mfaLoginSetupVerify: "/v1/mfa/login/setup-verify",

  // ─── Geo Access ───────────────────────────────────────────────────────
  getGoogleMapsKey: "/v1/config/google-maps-key",
  geoAccessPolicy: "/v1/companyAdmin/geo-access/policy",
  geoAccessOffices: "/v1/companyAdmin/geo-access/offices",
  geoAccessLogs: "/v1/companyAdmin/geo-access/logs",
  geoAccessEmployeeLocations: "/v1/companyAdmin/geo-access/employee-locations",

  // ─── Pipedrive Base ───────────────────────────────────────────────────
  pipedriveStatus: "/v1/pipedrive/status",
  pipedriveConnect: "/v1/pipedrive/connect",
  pipedriveDisconnect: "/v1/pipedrive/connection",
  pipedriveConnection: "/v1/pipedrive/connection",
  pipedriveLeadManager: "/v1/pipedrive/lead-manager",
  pipedriveDeals: "/v1/pipedrive/deals",
  pipedriveLeads: "/v1/pipedrive/leads",
  pipedrivePipelines: "/v1/pipedrive/pipelines",
  pipedriveStages: "/v1/pipedrive/stages",
  pipedriveUsers: "/v1/pipedrive/users",
  pipedrivePersonsSearch: "/v1/pipedrive/persons/search",
  pipedriveArchived: "/v1/pipedrive/deals/archived/summary",
  pipedriveSearch: "/v1/pipedrive/deals/search",
  pipedriveFilter: "/v1/pipedrive/deals/filter",

  // ─── Pipedrive - By ID ────────────────────────────────────────────────
  pipedriveDealById: (id) => `/v1/pipedrive/deals/${id}`,
  pipedriveLeadById: (id) => `/v1/pipedrive/leads/${id}`,
  pipedriveFollowers: (id) => `/v1/pipedrive/deals/${id}/followers`,
  pipedriveFollowersChangelog: (id) => `/v1/pipedrive/deals/${id}/followers/changelog`,

  // ─── Pipedrive - Deals Media ──────────────────────────────────────────
  pipedriveDealMedia: "/v1/pipedrive/deals",
  dealMedia: (dealId, kind) => `/v1/pipedrive/deals/${dealId}/${kind}`,
  dealNotes: (dealId, noteId) => noteId ? `/v1/pipedrive/deals/${dealId}/notes/${String(noteId).replace(/^notes?-/i, "")}` : `/v1/pipedrive/deals/${dealId}/notes`,
  dealFiles: (dealId, fileId) => fileId ? `/v1/pipedrive/deals/${dealId}/files/${String(fileId).replace(/^(files?|documents?)-/i, "")}` : `/v1/pipedrive/deals/${dealId}/files`,
  dealDocuments: (dealId, fileId) => fileId ? `/v1/pipedrive/deals/${dealId}/documents/${String(fileId).replace(/^(files?|documents?)-/i, "")}` : `/v1/pipedrive/deals/${dealId}/documents`,
  dealEmails: (dealId, mailId) => mailId ? `/v1/pipedrive/deals/${dealId}/emails/${String(mailId).replace(/^emails?-/i, "")}` : `/v1/pipedrive/deals/${dealId}/emails`,
  dealEmailCompose: (dealId) => `/v1/pipedrive/deals/${dealId}/emails/compose`,
  dealEmailSend: (dealId) => `/v1/pipedrive/deals/${dealId}/emails/send`,
  dealComments: (dealId, commentId) => commentId ? `/v1/pipedrive/deals/${dealId}/comments/${String(commentId).replace(/^comments?-/i, "")}` : `/v1/pipedrive/deals/${dealId}/comments`,

  // ─── Pipedrive - Leads Media ──────────────────────────────────────────
  pipedriveLeadMedia: "/v1/pipedrive/leads",
  leadMedia: (leadId, kind) => `/v1/pipedrive/leads/${leadId}/${kind}`,
  leadNotes: (leadId, noteId) => noteId ? `/v1/pipedrive/leads/${leadId}/notes/${String(noteId).replace(/^notes?-/i, "")}` : `/v1/pipedrive/leads/${leadId}/notes`,
  leadActivities: (leadId, activityId) => activityId ? `/v1/pipedrive/leads/${leadId}/activities/${String(activityId).replace(/^activity-/i, "")}` : `/v1/pipedrive/leads/${leadId}/activities`,
  leadFiles: (leadId, fileId) => fileId ? `/v1/pipedrive/leads/${leadId}/files/${String(fileId).replace(/^(files?|documents?)-/i, "")}` : `/v1/pipedrive/leads/${leadId}/files`,
  leadDocuments: (leadId, fileId) => fileId ? `/v1/pipedrive/leads/${leadId}/documents/${String(fileId).replace(/^(files?|documents?)-/i, "")}` : `/v1/pipedrive/leads/${leadId}/documents`,
  leadEmails: (leadId, mailId) => mailId ? `/v1/pipedrive/leads/${leadId}/emails/${String(mailId).replace(/^emails?-/i, "")}` : `/v1/pipedrive/leads/${leadId}/emails`,
  leadEmailCompose: (leadId) => `/v1/pipedrive/leads/${leadId}/emails/compose`,
  leadEmailSend: (leadId) => `/v1/pipedrive/leads/${leadId}/emails/send`,
  leadComments: (leadId, commentId) => commentId ? `/v1/pipedrive/leads/${leadId}/comments/${String(commentId).replace(/^comments?-/i, "")}` : `/v1/pipedrive/leads/${leadId}/comments`,

  // ─── Payroll / Everee ─────────────────────────────────────────────────
  payrollStatus: "/v1/companyAdmin/payroll/status",
  payrollConfirmPayment: "/v1/companyAdmin/payroll/confirm-payment",
  payrollCheckout: "/v1/companyAdmin/payroll/checkout",
  submitPayrollOnboarding: "/v1/companyAdmin/payroll/onboard",
};

export default pathObj;